export interface LinkDetail {
  url: string;
  linkText: string;
}

export interface searchDataReturn {
  billingCode: number;
  description: string | null | undefined;
  friendlyDescription: string;
  patientType: string;
}

export interface companyListReturn {
  name: string;
  plans?: insurancePlan[];
}

export interface insurancePlan {
  code?: string;
  name: string;
  shortName?: string;
}
export const UNSEEN_PLAN: insurancePlan = {
  name: 'unseenPlan',
  code: '0',
  shortName: 'unseenPlan',
};

export const UNSEEN_INSURER: companyListReturn = {
  name: 'unseenInsurer',
  plans: [UNSEEN_PLAN],
};

export interface locationDetailReturn {
  address: string;
  city: string;
  businessUnit: string;
  latitude: number;
  longitude: number;
  distance: number;
  name: string;
  phoneNumber: string;
  pricingPhoneNumber: string;
  postalCode: string;
  state: string;
  indexPosition?: number;
}

export interface SelectedPricingOptions {
  service?: searchDataReturn;
  zipCode?: string;
  insurer?: string;
  plan?: insurancePlan;
  location?: locationDetailReturn;
}

export interface StandardCharges {
  grossDollars: number;
  lastRefreshDate: string;
  discountedCashDollars?: number;
  maximumNegotiatedDollars?: number;
  minimumNegotiatedDollars?: number;
  payerNegotiatedDollars?: number;
}

export interface PlanPaymentDetails {
  outOfPocketPaid: string;
  outOfPocketTotal: string;
  outOfPocketMet: boolean;
  deductiblePaid: string;
  deductibleTotal: string;
  deductibleMet: boolean;
  coinsurance: string;
}

export enum Sections {
  service,
  location,
  insurance,
  priceguide,
}
